// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1zS6V","inner":"styles_inner__uHHLd","content":"styles_content__4OY0F","header":"styles_header__Dd1Cj"};